/**
 * Social Media Metadata Interface
 *
 * This interface defines the structure for social media meta tags including:
 * - Open Graph tags for Facebook, LinkedIn, and other platforms
 * - Twitter Card tags for Twitter/X
 * - Standard SEO meta tags
 *
 * Usage:
 * ```typescript
 * export async function generateMetadata() {
 *   return getMetaDataBySlug(
 *     "/your-page/",
 *     "Your Page Title",
 *     "Your page description",
 *     " | Nutrafol",
 *     "https://example.com/your-social-image.jpg", // Optional image
 *   );
 * }
 * ```
 */
export interface SocialMediaMetadata {
  title: string;
  description: string;
  robots?: string;
  alternates?: {
    canonical?: string;
  };
  openGraph: {
    title: string;
    description: string;
    url: string;
    image: string;
    type: string;
  };
  twitter: {
    card: string;
    title: string;
    description: string;
    image: string;
    creator?: string;
  };
}

export const createSocialMediaMetadata = (
  title: string,
  description: string,
  pathname: string,
  imageUrl?: string,
  author?: string
): SocialMediaMetadata => {
  const baseUrl = "https://nutrafol.com";
  const fullUrl = `${baseUrl}${pathname}`;

  return {
    title,
    description,
    robots: "index, follow",
    alternates: {
      canonical: fullUrl,
    },
    openGraph: {
      title,
      description,
      url: fullUrl,
      image: imageUrl,
      type: "website",
    },
    twitter: {
      card: "summary",
      title,
      description,
      image: imageUrl,
      creator: author,
    },
  };
};
